import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { FrontlineQOverviewResponse } from "./frontlineQAPI.types";

type FrontlineQRequestParams = {
  abo: string;
  aff: string;
  locale: string;
  period: string;
  isoCountryCode: string;
  isoCurrencyCode: string;
};

export const frontlineQAPI = createApi({
  reducerPath: "frontlineQAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getFrontlineQOverview: builder.query<FrontlineQOverviewResponse, FrontlineQRequestParams>({
      query: (params) => {
        const { abo, aff, locale, period, isoCountryCode, isoCurrencyCode } = params;
        const queryParams = new URLSearchParams({
          Abo: abo,
          Aff: aff,
          Locale: locale,
          Period: period,
          IsoCountryCode: isoCountryCode,
          IsoCurrencyCode: isoCurrencyCode,
        });

        return `/incentives-v2/api/frontlineq/overview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetFrontlineQOverviewQuery } = frontlineQAPI;
